export default __webpack_public_path__ + "static/media/step-3.f59e352b.png";